import React from "react";
import { Button, Col, Container, Row, Card, Spinner } from "react-bootstrap";
import SuccessfulTransactionIcon from "../../assests/images/payment-completed.png";
import { useNavigate } from "react-router-dom";


const SuccessfulTransaction = () => {
  const navigate = useNavigate();
  return (
    <div className="successful-transaction-page">
      <Container className="text-center">
        <Card className="shadow-lg p-3 mb-5 bg-white rounded payment-card">
          <Card.Body>
            <Card.Subtitle className="d-flex justify-content-center align-items-center">
              <img src={SuccessfulTransactionIcon} alt="Payment Status Icon" width="130" height="auto" />
            </Card.Subtitle>
            <Card.Text className="py-3 m-0">
              <Container>
                <Row>
                  <Col className="payment-title">Payment Success!</Col>
                </Row>
                <Row>
                  <Col className="payment-description">It's our pleasure to offer you our products</Col>
                </Row>
              </Container>
            </Card.Text>
            <div className="d-flex justify-content-center align-items-center">
              <Button variant="success mx-auto" onClick={() => navigate("/", { replace: true })}>
                Continue
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default SuccessfulTransaction;
